<template>
  <div>
    <a-modal
      title="巡视备注"
      width="660px"
      centered
      :visible="showDialog"
      :confirm-loading="editNoteLoading"
      dialogClass="backup-dialog"
      okText="确定提交"
      :zIndex="1001"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-textarea
        v-model="backupValue"
        placeholder="请输入备注"
        :auto-size="{ minRows: 13, maxRows: 13 }"
      />
    </a-modal>
  </div>
</template>
<script>
export default {
  name: 'BackupDialog', // 巡视备注组件
  props: {
    showDialog: Boolean,
    defaultBackup: String,
    classroomCodeProp: String
  },
  data() {
    return {
      backupValue: '',
      editNoteLoading: false
    };
  },
  watch: {
    defaultBackup(nVal) {
      this.backupValue = nVal
    }
  },
  methods: {
    handleOk(e) {
      this.inspectionEditNotes()
      this.$emit('setBackupDialog', {showBackupDialog: false})
    },
    handleCancel(e) {
      this.$emit('setBackupDialog', {showBackupDialog: false})
    },
    // 添加备注
    async inspectionEditNotes() {
      if (this.editNoteLoading) return
      this.editNoteLoading = true
      const { classroomCode } = this.$route.query
      const { backupValue, defaultBackup } = this
      try {
        const res = await this.$http.inspectionEditNotes({
          classroomCode: classroomCode || this.classroomCodeProp,
          notes: backupValue
        })
        if (res.code !== 200) throw new Error()
        this.$message.success('备注保存成功！')
      } catch (error) {
        this.$message.error('备注保存失败！')
        this.backupValue = defaultBackup
      }
      this.editNoteLoading = false
    },
  },
};
</script>
<style lang="scss" >
.backup-dialog{
  .ant-modal-footer{
    text-align: center;
    .ant-btn{
      min-width: 104px;
      height: 38px;
      &:hover{
        color:#5F60D3;
        border-color:#5F60D3;
      }
      &.ant-btn-primary{
        background-color: #5F60D3;
        border-color: #5F60D3;
        margin-left: 16px;
        &:hover{
          opacity: 0.9;
          color: #fff;
        }
      }
    }

  }
}
</style>